<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card-header">
                <span>{{ title }}</span>
            </div>
            <div class="card border-0">
                <div class="card-body gray-bg contacts-block">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row mr-0 medical-table">
                                <div v-for="(contact,key) in preparedContacts"
                                     v-if="showContact(contact, key)"
                                     :class="contactClass(key)"
                                >
                                    <div v-for="(allContact, allKey) in allPreparedContacts"
                                         v-if="allContact.title === contact.title"
                                    >
                                        <div class="row d-flex align-items-center">
                                            <div
                                                class="sb-benefit-main-phone-title"
                                                :class="{
                                                    'my-3': (allPreparedContacts.filter((con) => con.title === allContact.title).length === 1),
                                                    'my-1': (allPreparedContacts.filter((con) => con.title === allContact.title).length === 1),
                                                    'col-sm-7': (allContact.type === 'phone' || allContact.type === 'phone_string'),
                                                    'col-sm-6': !(allContact.type === 'phone' || allContact.type === 'phone_string')
                                                }"
                                            >
                                                <span v-if="(allPreparedContacts.findIndex(
                                                                object => object.title === allContact.title
                                                            ) === allKey)"
                                                      v-html="preparedTitle(allContact.title)"></span>
                                            </div>
                                            <div
                                                class="sb-benefit-main-phone"
                                                :class="{
                                                    'my-3': (allPreparedContacts.filter((con) => con.title === allContact.title).length === 1),
                                                    'my-1': !(allPreparedContacts.filter((con) => con.title === allContact.title).length === 1),
                                                    'col-sm-5': (allContact.type === 'phone' || allContact.type === 'phone_string'),
                                                    'col-sm-6': !(allContact.type === 'phone' || allContact.type === 'phone_string')
                                                }"
                                            >
                                                <template v-if="allContact.type === 'website'">
                                                    <a :href="allContact[allContact.type]"allContact
                                                        target='_blank'
                                                        class="contact-link"
                                                       :class="allContact[allContact.type].length <= 33 ? 'contact-link-no-wrap' : ''"
                                                        title="Open Website"
                                                    >
                                                        {{ webSite(allContact[allContact.type]) }}
                                                    </a>
                                                </template>
                                                <template v-else-if="allContact.type === 'email'">
                                                    <a :href="'mail:'+allContact[allContact.type]"
                                                        target='_blank'
                                                        class="contact-link"
                                                       :class="allContact[allContact.type].length <= 33 ? 'contact-link-no-wrap' : ''"
                                                        title="Open Website"
                                                    >
                                                        {{ allContact[allContact.type] }}
                                                    </a>
                                                </template>
                                                <template v-else>
                                                    {{ allContact[allContact.type] }}
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row bt-white" v-if="showAllPhones()">
                        <div class="col-md-12 text-center">
                            <a href="#"
                               class="btn-block btn-hp-view-all pt-2 gray-bg"
                               aria-label="See More Contact Information"
                               @click.prevent="showMore = !showMore"
                            >
                                <i class="fas" :class="chevronDirection"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlanContacts',
    props: [
        'contacts',
        'title'
    ],
    data() {
        return {
            allPreparedContacts: [],
            preparedContacts: [],
            showMore: false,
            usedTitles: []
        }
    },
    computed: {
        chevronDirection() {
            return this.showMore ? 'fa-chevron-up' : 'fa-chevron-down';
        }
    },
    mounted() {
        this.prepareContacts();
    },
    methods: {
        contactClass(key) {
            if (window.screen.width > 767 && (key < 2 || this.showMore)) {
                const length = this.preparedContacts.length;
                if ((length%2 && length - key > 1) || (!!length%2 && length - key > 2)) {
                    return 'col-md-6 border-bottom';
                }
            }

            return 'col-md-6';
        },
        prepareContacts() {
            this.allPreparedContacts = this.contacts.filter(function (contact) {
                return contact.title && contact[contact.type];
            });

            this.preparedContacts = this.allPreparedContacts.reduce(function (p, c) {
                if (!p.some(function (el) { return el.title === c.title; })) p.push(c);
                return p;
            }, []);
        },
        showAllPhones() {
            return this.contacts.filter(hpc => (hpc.type === 'phone'||hpc.type === 'phone_string')).length > 2;
        },
        showContact(contact, key) {
            return key < 4 || this.showMore;
        },
        preparedTitle(title) {
            return {
                'Carrier Phone': 'Compass Rose'
            }[title] || title;
        },
        webSite(url) {
            return (new URL(url)).hostname;
        }
    }
}
</script>

<style scoped>

</style>
